import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  voucherList: {
    list: {
      data: [],
      total: 0,
    },
  },
  redemptionList: {
    list: {
      data: [],
      total: 0,
    },
  },
  redemption: {
    data: {},
  },
  voucherData: {},
  accumulateCalculationList: {
    list: {
      data: [],
      total: 0,
    },
  },
  balance: '',
  cartAdditionalAttributesInCompleteIds: {
    product_ids: [],
    kitting_ids: [],
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
